import { length } from 'ramda';

import { clear, unprefix } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toImageFromProp } from '../../fields/image';
import { toLinkFromProp } from '../../fields/link';
import { toText, toTextFromProp } from '../../fields/text';

const getPushsUID = (items) =>
  (items || [])
    .map(({ child_pushs }) => child_pushs?.uid && { uid: child_pushs.uid })
    .filter(Boolean);

export const childPushsSlice = ({ primary, items }) => {
  const { title, desc } = unprefix('child_page', primary);
  const childPushs = getPushsUID(items);

  if (length(childPushs)) {
    return clear({
      type: CommonSliceType.CHILD_PUSHS,
      title: toText(title),
      description: toText(desc),
      childPushs,
    });
  }
};

export const coldPushSlice = ({ primary }) =>
  clear({
    type: CommonSliceType.COLD_PUSH,
    title: toTextFromProp('title', primary),
    fullName: toTextFromProp('fullName', primary),
    job: toTextFromProp('job', primary),
    image: toImageFromProp('image', primary),
    link: toLinkFromProp('link', primary),
  });
